__turbopack_context__.v({
  "page-body-wrap": "QvYOzq_page-body-wrap",
  "paragraph-content": "QvYOzq_paragraph-content",
  "wrap-container": "QvYOzq_wrap-container",
  "wrap-content": "QvYOzq_wrap-content",
});
